<template>
  <div>
    <div class="maskPanel" v-if="show || showSubmitSuccess"></div>
    <div class="modal" v-if="show">
      <div style="text-align: left; width: calc(100% - 80px);">
        <div style="display: flex; justify-content: center; white-space: nowrap;">
          <h1 style="margin-bottom: 10px;">Withdraw Your WorldKey Token</h1>
        </div>
      </div>
      <form @submit.prevent="handleSubmit" style="width: calc(100% - 80px);">
        <!-- Work Email -->
        <div class="form-group">
          <label for="token">Token</label>
          <div style="position: relative;">
            <img src="../assets/svg/Icon_Coin.svg" alt="" style="position: absolute; width: 36px; height: 36px; left: 4px; top: 4px;">
            <input
              v-model="form.token"
              placeholder="token"
              id="token"
              maxlength="255"
              :class="{'error': errors.token}"
              style="padding-left: 40px;"
              disabled="true"
            />
          </div>
          <span v-if="errors.token" class="error-message">{{ errors.token }}</span>
        </div>
        <div class="form-group">
          <label for="network">Network</label>
          <div style="position: relative;">
            <img style="position: absolute; width: 28px; height: 28px; left: 6px; top: 8px;" alt="" src="data:image/png;base64,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">
            <input
              v-model="form.network"
              placeholder="network"
              id="network"
              maxlength="255"
              :class="{'error': errors.network}"
              style="padding-left: 40px;"
              disabled="true"
            />
          </div>
          <span v-if="errors.network" class="error-message">{{ errors.network }}</span>
        </div>
        <div class="form-group">
          <label for="amount">Amount</label>
          <input
            type="number"
            v-model="form.amount"
            placeholder="Min 300"
            id="amount"
            maxlength="255"
            :class="{'error': errors.amount}"
            oninput="value=value.replace(/^0(0+|\d+)|[^\d]+/g,'')"
          />
          <span v-if="errors.amount" class="error-message">{{ errors.amount }}</span>
        </div>
        <div class="form-group">
          <label for="address">Address</label>
          <input
            v-model="form.address"
            placeholder="Enter Address"
            id="address"
            maxlength="255"
            :class="{'error': errors.address}"
          />
          <span v-if="errors.address" class="error-message">{{ errors.address }}</span>
        </div>

        <!-- 提交按钮 -->
        <div class="form-group form-actions">
          <button type="button" class="cancel-btn" @click="closeMask">Cancel</button> <!-- 左边的取消按钮 -->
          <button type="submit" class="submit-btn">Submit</button> <!-- 右边的提交按钮 -->
        </div>
      </form>

    </div>
    <div class="modal" v-if="showSubmitSuccess" style="padding: 75px 75px 50px 75px;">
      <img src="../assets/logo/biglogo.png" style="width: 200px;" />
      <span style="font-size: 16px; text-align: center;">
        You have withdrawed {{form.amount}} WorldKey Token successfully!
      </span>
      <button class="submit-btn" @click="closeSuccessModal" style="margin-top: 20px; border: none; font-weight: 600; padding: 12px 18px; font-size: 16px;">Back to home</button>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import * as api from '../service/getData'
import {newWithdraw, withdraw} from '../service/getData'

export default {
  name: 'BuyData',
  props: ['totalToken'],
  data () {
    return {
      show: false,
      showSubmitSuccess: false,
      form: {
        token: 'JJT',
        network: 'BNB Chain',
        amount: '',
        address: ''
      },
      errors: {
        token: false,
        network: false,
        amount: false,
        address: false
      }
    }
  },
  methods: {
    showBuyData () {
      this.show = true
    },
    closeMask () {
      this.show = false
    },
    validateForm () {
      let valid = true
      this.errors = {}
      // 验证必填字段
      if (!this.form.amount) {
        this.errors.amount = 'Amount is required.'
        valid = false
      } else if (this.form.amount < 300) {
        this.errors.amount = 'The mininum amount is 300.'
        valid = false
      } else if (this.form.amount > this.totalToken) {
        this.errors.amount = 'You don\'t have enough tokens.'
        valid = false
      }
      if (!this.form.address) {
        this.errors.address = 'Wallet address is required.'
        valid = false
      }
      return valid
    },
    async handleSubmit () {
      if (this.validateForm() && Cookies.get('address')) {
        const obj = {
          address: Cookies.get('address'),
          amount: parseInt(this.form.amount, 10),
          to_address: this.form.address
        }
        console.log(obj)
        const res = await api.newWithdraw(obj)
        this.$prompt.success('Withdraw submit success')
        this.closeMask()
        this.showSubmitSuccess = true
        // alert('Form submitted successfully!');
      }
    },
    closeSuccessModal () {
      this.showSubmitSuccess = false
      this.$emit('submitSuccess')
    }
  }
}
</script>

<style scoped>
.modal {
  position:fixed;
  z-index:100;
  background:#000000dd;
  top:50%;
  left:50%;
  transform: translate(-50%,-50%);
  display: flex;
  width: 480px;
  padding: 44px 80px;
  flex-direction: column;
  align-items: center;
  border-radius: var(--Corner01, 24px);
  gap: 20px;
  border: 2px solid #ffffff;
}
/* 基本样式 */
.form-container {
  background: #111;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  padding: 40px;
  width: 100%;
  max-width: 600px;
}

.form-row {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.form-group {
  margin-bottom: 25px;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.form-group label {
  display: block;
  font-size: 16px;
  color: #fff;
  margin-bottom: 8px;
  font-weight: 500;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 12px 18px;
  border: 1px solid #fff;
  border-radius: 6px;
  background-color: #fff;
  color: #000;
  font-size: 16px;
  font-weight: 400;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.3s ease, background-color 0.3s ease;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  //border-color: #ff7e5f;
  //background-color: #333;
}

.form-group input.error,
.form-group textarea.error {
  //border-color: red;
}

.error-message {
  color: red;
  font-size: 12px;
  margin-top: 5px;
}

.checkbox-container {
  margin-bottom: 20px;
}

.checkbox-container label {
  color: #fff;
  font-size: 14px;
}

.radio-group {
  display: flex;
  justify-content: left;
}

.radio-label {
  margin-right: 32px;
  font-size: 16px;
  color: #fff;
  display: flex;
  align-items: center;
}
.radio-label span {
  margin-left: 8px;
}
.form-group input[type='radio'] {
  width: 20px;
  height: 20px;
}
.maskPanel {
  top:0;
  left:0;
  position:fixed;
  z-index:99;
  opacity: 0.7;
  background: var(--neutral-900, #101313);
  width:100%;
  height:100%;
}
.form-actions {
  display: flex;
  justify-content: space-between; /* 左右对齐分布 */
  flex-direction: row;
  gap: 20px; /* 两个按钮之间的间距 */
  margin: 32px 0 0 0;
}

.submit-btn {
  padding: 12px 36px;
  background: var(--button-linear-default, linear-gradient(90deg, #0FF 25.99%, #6DFBB7 100%));
  border: 1px solid #fff;
  border-radius: 6px;
  color: black;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.submit-btn:hover {
  background-color: #feb47b; /* 提交按钮的悬停效果 */
}

.cancel-btn {
  padding: 12px 36px;
  background-color: #000;
  border: 1px solid #fff;
  border-radius: 6px;
  color: white;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.cancel-btn:hover {
  background-color: #555; /* 取消按钮的悬停效果 */
}
</style>



// WEBPACK FOOTER //
// src/components/WithDraw.vue